import { render } from "./homeCarousel.vue?vue&type=template&id=c811e850&scoped=true"
import script from "./homeCarousel.vue?vue&type=script&lang=js"
export * from "./homeCarousel.vue?vue&type=script&lang=js"

import "./homeCarousel.vue?vue&type=style&index=0&id=c811e850&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/CIS-school.vip.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c811e850"]])

export default __exports__